import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { leagueIds, sportIds } from 'src/constants'
import { canadaPlanData } from 'src/constants/planData/canadaPlanData'

export default (props) => {
  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/CONCACAF_2021_LP_19s.mp4'}
      title="Watch the CONCACAF Gold Cup"
      subtitle="See Team Canada, U.S.A, Mexico & more"
      networkSet="canada_sports"
      customNetworks={['onesoccer']}
      sportId={sportIds.Soccer}
      leagueId={leagueIds['CONCACAF Nations League']}
      planCardsConfig={{
        plans: [canadaPlanData.sports],
      }}
    />
  )
}
